"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTemplateUtils = void 0;
const common_1 = require("@finley-technologies/common");
const registry_1 = require("../dbNodes/registry");
const remintIds_1 = require("./remintIds");
const createTemplateUtils = (params) => {
    const prefix = `[artifactDocumentId:${params.artifactDocumentId}]`;
    // only BE code should use this utility
    (0, common_1.finleyAssert)(common_1.utils.EnvUtils.isBackend(), `${prefix}: createTemplateUtils should only be used in the backend`);
    return {
        /**
         * Clones the graph from a template.
         * This does not anonymize the graph,
         * and should only be used with trusted templates.
         */
        cloneTemplateGraph: ({ newArtifactDocumentId, cloneMap, }) => {
            const oldIdToNewIdMap = new Map(); // oldId => newId
            const newArtifacts = params.artifacts.map((artifact) => {
                const node = registry_1.dbNodeRegistry[artifact.type];
                (0, common_1.finleyAssert)(node, `reached Unreachable ${artifact.type}`);
                const newArtifact = node.cloneArtifact({
                    artifact,
                    newArtifactDocumentId,
                    cloneMap,
                    errorPrefix: prefix,
                });
                (0, common_1.finleyAssert)(artifact.id !== newArtifact.id, `${prefix}: artifact id must change during clone: ${artifact.id} => ${newArtifact.id}`);
                oldIdToNewIdMap.set(artifact.id, newArtifact.id);
                return newArtifact;
            });
            // now we need to update dependencies.
            const newDependencies = (0, remintIds_1.rewireDependencies)(params.dependencies, (oldId, dependency) => {
                const newId = oldIdToNewIdMap.get(oldId);
                (0, common_1.finleyAssert)(newId, `${prefix}: dependency not found in oldIdToNewIdMap: ${JSON.stringify(dependency)}`);
                return newId;
            });
            return {
                artifacts: newArtifacts,
                dependencies: newDependencies,
            };
        },
    };
};
exports.createTemplateUtils = createTemplateUtils;
//# sourceMappingURL=templateClone.js.map